__webpack_require__.p = "/marvel-lcg-randomizer/";